<template>
  <div class="wrapp">
    <div class="row">
      <div class="col-12">
        <h2>Em Desenvolvimento</h2>
        <b-alert show variant="info" class="explain">
          Esta página está em desenvolvimento.
        </b-alert>
      </div>
    </div>
    <hr>
  </div>
</template>

<script>
/* eslint-disable */

export default {
  name: 'Developing',
  components: {},
  data: () => ({}),
  watch: {},
  computed: {},
  methods: {},
  created() {},
  async mounted() {},
};
</script>

<style lang="scss" scoped>
.wrapp {
  padding: 16px;
  max-height: calc(100vh - 72px);
  background-color: #f1f1f1;
  overflow: auto;
}
.explain {
  background-color: transparent;
  border: none;
  color: #212529;
}
</style>
